import { ExternalLink } from "lucide-react";
import { C } from "../../theme/tokens";
import { isRussianTimezone, REG_LINK, REG_LINK_RU } from "../../data/referralLinks";

export function RegLinkButton({ t, label }) {
  const russianTimezone = isRussianTimezone();
  const primaryLink = russianTimezone ? REG_LINK_RU : REG_LINK;
  const alternateLink = russianTimezone ? REG_LINK : REG_LINK_RU;
  const alternateLabel = russianTimezone ? t.reg_link_alt_main : t.reg_link_alt_ru;

  return (
    <div>
      <a
        href={primaryLink}
        target="_blank"
        rel="noreferrer"
        style={{
          marginTop: 18,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          textDecoration: "none",
          padding: "15px 18px",
          borderRadius: 14,
          background: `linear-gradient(120deg, ${C.greenBright} 0%, ${C.green} 100%)`,
          color: "#0b0d13",
          fontFamily: "'Space Grotesk', sans-serif",
          fontWeight: 700,
          fontSize: 15,
        }}
      >
        {label}
        <ExternalLink size={16} />
      </a>
      <a
        href={alternateLink}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "block",
          marginTop: 8,
          color: C.secondary,
          fontSize: 11.5,
          textAlign: "center",
          textDecoration: "underline",
        }}
      >
        {alternateLabel}
      </a>
    </div>
  );
}
